import React from 'react';
import { DateTime } from 'luxon';

import Layout from 'ds/Layout';
import Text from 'ds/Text';

interface Props {
  date: DateTime;
}

const CalendarDateDisplay: React.FC<Props> = ({ date }) => {
  const dateIsToday = date.startOf('day').equals(DateTime.now().startOf('day'));
  const dateIsPast = date < DateTime.now().startOf('day');

  return (
    <Layout
      {...(dateIsToday ? { color: 'blue-500' } : {})}
      height={20}
      width={32}
      borderRadius={1_000}
      align="center"
      justify="center"
      display="inline-flex"
      opacity={dateIsPast ? 0.4 : undefined}
    >
      <Text size="body-xs" color={dateIsToday ? 'white' : 'gray-900'} align="center" semibold>
        {date.day}
      </Text>
    </Layout>
  );
};

export default CalendarDateDisplay;
